module.exports = __webpack_public_path__ + "img/LEGAL-PG.a0ecaac6.svg";